import classNames from 'classnames'
import { motion } from 'framer-motion'
import {
  CSSProperties,
  useLayoutEffect,
  useState,
} from 'react'

import styles from './CircularText.module.scss'
import { MatrixEffectText } from './MatrixEffectText'
import { generateRandomString } from './helpers'
import { QuestViewState } from './types/QuestCircleTypes'

type Props = {
  offset: number
  text: string
  radius: string
  reveal?: boolean
  compact?: boolean
  matrixEffectTimeout?: number
  angleStep?: number
  state: QuestViewState
}

export const CircularText = ({
  offset,
  text,
  radius,
  matrixEffectTimeout = 0,
  reveal = false,
  compact = false,
  angleStep = 40,
  state,
}: Props) => {
  const angleStepValue = 360 / angleStep
  const [viewText, setViewText] = useState(
    state === QuestViewState.Showed ? text : generateRandomString(text.length)
  )
  const [animated, setAnimated] = useState(false)
  const [complete, setComplete] = useState(false)

  useLayoutEffect(() => {
    if (!matrixEffectTimeout) {
      return
    }
    setTimeout(() => {
      setComplete(true)
    }, matrixEffectTimeout)
  }, [])

  useLayoutEffect(() => {
    if (reveal) {
      setTimeout(() => {
        setAnimated(true)
        setViewText(text)
      }, 1000)
    }
  }, [reveal, text])

  const letterStyle = (index: number): CSSProperties => {
    const angle = index * angleStepValue + offset
    return {
      transform: `translate(-50%, -50%) rotate(${angle}deg) translateY(${radius})`,
    }
  }

  return (
    <motion.div
      key={`circular-${text}`}
      initial={{ opacity: 0 }}
      animate={{
        opacity: text ? 1 : 0.5,
      }}
      transition={{
        duration: 0.6,
        ease: 'easeInOut',
      }}
    >
      {Array.from(viewText).map((char, index) => (
        <span
          key={index}
          style={letterStyle(index)}
          className={classNames([
            compact ? styles.letterDot : styles.letterQuest,
          ])}
        >
          {animated && !complete ? (
            <MatrixEffectText>{char}</MatrixEffectText>
          ) : (
            char
          )}
        </span>
      ))}
    </motion.div>
  )
}
